import { handleErrors } from "./errors";
import { Settings, _RecaptchaResults } from "./types";

export async function loadRecaptcha(onSubmit: (token: string) => void, settings: Settings) {
  const id = settings.name + "-recaptcha";

  async function waitForRecaptcha() {
    return new Promise((resolve) => {
      const rate = 50;
      let elapsed = 0;

      const interval = setInterval(() => {
        elapsed += rate;

        if (elapsed >= settings.recaptchaTimeout) {
          clearInterval(interval);
          resolve(false);
        }

        if (
          window.grecaptcha &&
          window.grecaptcha.ready &&
          window.grecaptcha.render &&
          window.grecaptcha.reset &&
          window.grecaptcha.execute
        ) {
          clearInterval(interval);
          resolve(true);
        }
      }, rate);
    });
  }

  settings.internal.ready = false;

  if (settings.disableButtonWhileRecaptchaLoading) {
    settings.submitEl.disabled = true;
  }

  const start = new Date().getTime();
  const recaptchaIsLoaded = await waitForRecaptcha();
  const time = new Date().getTime() - start;

  if (recaptchaIsLoaded) {
    const recaptchaEl = document.createElement("div");
    recaptchaEl.id = id;
    recaptchaEl.classList.add("recaptcha");
    recaptchaEl.style.display = "none";

    settings.el.append(recaptchaEl);

    grecaptcha.ready(() => {
      settings.recaptchaWidget = grecaptcha.render(recaptchaEl, {
        sitekey: settings.recaptchaSiteKey,
        size: "invisible",
        callback: onSubmit,
        "error-callback": () => {
          handleErrors(
            [
              {
                errorCode: 5,
                errorMessage: "Error verifying reCAPTCHA, please try again."
              }
            ],
            settings
          );
        }
      });

      settings.recaptchaLoaded = true;
      settings.events.recaptchaLoaded(time);
    });
  } else {
    console.warn(
      `reCAPTCHA not found on page after ${settings.recaptchaTimeout}ms. reCAPTCHA is disabled for form: ${settings.name}`
    );
  }

  if (settings.disableButtonWhileRecaptchaLoading) {
    settings.submitEl.disabled = false;
  }

  settings.internal.ready = true;
}

export async function getRecaptchaToken(settings: Settings) {
  grecaptcha.reset(settings.recaptchaWidget);
  grecaptcha.execute(settings.recaptchaWidget);
}

export async function validateRecaptchaToken(token: string): Promise<_RecaptchaResults> {
  const response = await fetch("https://cloud.email.wwwincnews.com/recaptcha", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ token })
  });

  const data = await response.json();

  return data;
}
